import { useState } from 'react'
import { Calendar } from 'lucide-react'
import ConnectGoogleButton from './ConnectGoogleButton'
import CalDAVConnectModal from './CalDAVConnectModal'

interface Props {
  onConnected?: (accountId: number) => void
}

export default function ConnectCalendarEmptyState({ onConnected }: Props) {
  const [caldavOpen, setCaldavOpen] = useState(false)
  return (
    <>
      <div className="flex flex-col items-center text-center gap-4 py-16">
        <div className="w-16 h-16 rounded-full bg-primary/10 text-primary flex items-center justify-center">
          <Calendar size={28} />
        </div>
        <div>
          <h2 className="text-lg font-semibold text-foreground">Connect your calendar</h2>
          <p className="text-sm text-muted-foreground mt-1 max-w-xs">
            Sign in with Google to use Gmail and Calendar together, or connect Apple iCloud / any CalDAV server.
          </p>
        </div>
        <div className="flex flex-col gap-2 w-72">
          <ConnectGoogleButton module="calendar" />
          <button
            type="button"
            onClick={() => setCaldavOpen(true)}
            className="inline-flex items-center justify-center gap-2 rounded-md border border-border bg-card px-4 py-2 text-sm font-medium text-foreground hover:bg-muted transition"
          >
            Add Apple / CalDAV
          </button>
        </div>
      </div>
      {caldavOpen && (
        <CalDAVConnectModal
          onClose={() => setCaldavOpen(false)}
          onConnected={(id) => { setCaldavOpen(false); onConnected?.(id) }}
        />
      )}
    </>
  )
}
